<template>
  <form>
    <PageHeader title="apollo-RP - Approval" class="list">
      <template #title-header-content></template>
      <template #page-header-content>
          <div class="mb-auto pl-4 flex items-center h-10">
            <h1 class="text-lg font-bold text-white flex items-center">            
              <Icon iconName="UserGroup" class="w-7 h-7 mr-2" /> <span class="mt-0">承認ルート 一覧</span>
            </h1>
            <div v-if="auth" class="pl-2 mb-100px ml-auto">
              <PrimaryButton text="新規" size="normal hover:bg-pink-400" class="new" @click="edit({})"/>
            </div>
          </div>
      </template>
    </PageHeader>
    <main class="absolute top-32 w-screen bottom-4 -mt-2 leading-8 list text-sm">
      <div class="mx-auto px-2 sm:px-4 lg:px-8 h-full">
        <div class="bg-white rounded-md border border-gray-200 overflow-auto h-full">
          <table class="table">
            <thead class="th sticky top-0">
              <tr class="column">
                  <th class="th1">優先度</th>
                  <th class="th2">ルート名</th>
                  <th class="th2">承認者1</th>
                  <th class="th2">承認者2</th>
                  <th class="th2">対象部署</th>
                  <th v-if="auth" class="th1"></th>
                  <th v-if="auth" class="th1"></th>
              </tr>
            </thead>
            <tbody v-for="(list, index) in approval" :key="index">
              <tr :class="setColor(index)">
                <!-- 優先度 -->
                <td class="td1">{{list.priority}}</td>
                <!-- ルート名 -->
                <td class="td2">{{list.routeName}}</td>
                <!-- 承認者1 -->
                <td class="td2"><pre>{{getUser(list.approver1)}}</pre></td>
                <!-- 承認者2 -->
                <td class="td2"><pre>{{getUser(list.approver2)}}</pre></td>
                <!-- 対象部署 -->
                <td class="td2"><pre>{{getName(list.departments)}}</pre></td>
                
                <td v-if="auth" class="td1"><PrimaryButton text="編集" @click="edit(list)" /></td>
                <td v-if="auth" class="td1"><PrimaryButton text="削除" @click="deleteData(list)" size="normal bg-indigo-200 text-indigo-700 hover:bg-indigo-300"/></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </main>
    <!-- 承認編集・新規登録モーダル -->
    <EstimateApprovalModal 
      v-model="modalShow"
      :target="editData"
      :open="modalShow"
      @modalClose="modalClose"
    />
  </form>
</template>
<script>

import Icon from '@components/Icon.vue'
import PageHeader from '@components/PageHeader.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import EstimateApprovalModal from '../components/EstimateApprovalMasterModal.vue'
import * as estimateManager from '@managers/estimateManager'
import * as dialogs from '@libs/dialogs'
import * as utils from '@libs/utils'
import * as logManager from '@managers/logManager'

import PageModel from '../../main/pages/PageModel.vue'

export default {
  extends: PageModel,
  components: {
    Icon,
    PrimaryButton,
    PageHeader,
    EstimateApprovalModal
  },

  data() {
    return {
      // 承認マスタリスト
      approval: [],
      // モーダル表示
      modalShow: false,
      // 編集する内容
      editData: {},
      // ログインユーザーが承認権限者 true:権限者である
      auth: false,
      // 部署リスト
      depList: this.$store.getters.departmentList
    }
  },

  created() {
    this.getApproval()
  },

  computed: {
    /**
     * スタッフ名取得
     */
    getUser() {
      return (list) => {
        if (list && list.length) {
          const res = list.map((row) => row.userName)
          return res.join('\r\n')
        }
        return ''
      }
    },

    /**
     * 部署名取得
     */
    getName() {
      return (list) => {
        if (list && list.length) {
          const res = []

          if (list.includes('')) {
            return '全部署'
          }

          for (let i = 0; i < this.depList.length; i++) {
            const row = this.depList[i]
            if (list.includes(row.departmentId)) {
              res.push(row.name)
            }
          }

          return res.join('\r\n')
        } else {
          return '全部署'
        }
      }
    }
  },

  methods: {
    /**
     * 承認データ取得
     */
    async getApproval() {
      
      if (this.$store.getters.auth && (this.$store.getters.auth.adminAuth || this.$store.getters.auth.estimateApproveAuth)) {
        this.auth = true
      }

      let list = await estimateManager.getApprover(this)
      if (list.length) {
        this.approval = list
      }
    },

    /**
     * 編集イベント
     * @param data 編集内容
     */
    edit(data) {
      this.modalShow = true
      this.editData = utils.clone(data)
    },

    /**
     * 背景色設定
     */
    setColor(i) {
      if (i % 2 != 0) {
        return 'bg-blue'
      }
    },

    /**
     * モーダルを閉じる
     */
    modalClose() {
      this.modalShow = false
      this.getApproval()
    },

    /**
     * 削除イベント
     * @param list 削除するデータ
     */
    async deleteData(list) {
      const dialogResult = await dialogs.showWarningConfirmDialog('削除', '削除してよろしいですか？')
      if (dialogResult === 'YES') {
        let registApp = await estimateManager.deleteApprover(this, list.routeName)
        if (!registApp) {
          await dialogs.showErrorDialog('エラー', '削除できませんでした。')
          return
        }
        logManager.recording(this, logManager.Loglevel.INFO, '承認ルート', '削除', '承認ルート（' + list.routeName + '）を削除しました。')
        this.getApproval()
      }
    }
  }
}
</script>

<style scoped>
.list {
  min-width: 900px;
}

.table {
  width: 100%;
}

.column th {
  height: 50px;
  background: #edecf7;
}

.bg-blue {
  background: rgb(243 247 249);
}

.th1 {
  white-space: nowrap;
  text-align: center;
  padding: 10px;
}

.th2 {
  text-align: left;
  white-space: nowrap;
  padding: 10px;
}

.td1 {
  white-space: nowrap;
  text-align: center;
  padding: 10px;
}

.td2 {
  padding-left: 30px;
  padding: 10px;
  white-space: nowrap;
}

.new {
  margin-top: 103px;
  width: 200px;
  background: #eb94c8;
}
</style>